import store from '../store';
import getDefaultPreviewLinesToShow from '../../utils/getDefaultPreviewLinesToShow';

export default function getShowPreviewLinesInListView(): number {
    return store().showPreviewLinesInListView ?? getDefaultPreviewLinesToShow();
}
